import { ScopeButton } from '@monorepo/shared-lib';
import { Col, Form, Row, Select, Typography } from 'antd';
import { FormSelect } from 'components/Custom/selects';
import { StaffMember } from 'pages/account';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface ChangeOwnerProps {
  updateOwner: (accountId: string) => void;
  staffMembers: StaffMember[];
}

interface ChangeOwnerValues {
  staffMember: string;
}

const { Paragraph } = Typography;

export const ChangeOwner: React.FC<ChangeOwnerProps> = ({
  updateOwner,
  staffMembers,
}) => {
  const { t } = useTranslation();
  const handleChangeOwner = (values: ChangeOwnerValues) =>
    updateOwner(values?.staffMember);
  return (
    <Form layout="vertical" onFinish={handleChangeOwner}>
      <Row justify={'space-between'}>
        <Col span={24}>
          <Paragraph
            style={{
              fontSize: '16px',
              fontWeight: '400',
              lineHeight: '24px',
              textAlign: 'left',
              color: 'var(--color-text-muted, #5a6a6a)',
              marginBottom: '40px',
            }}
          >
            {t('other.transfer-ownership-description')}
          </Paragraph>
        </Col>

        <Col span={24}>
          <Form.Item
            name="staffMember"
            rules={[
              {
                required: true,
                message: t('common.required-field'),
              },
            ]}
          >
            <FormSelect //@ts-ignore
              width="100%"
              height="45px"
              bordercolor="var(--color-border, #dbeae3)"
              placeholder={t('other.select-user')}
            >
              {staffMembers &&
                staffMembers.map((sm, idx) => (
                  <Select.Option key={idx} value={sm.id}>
                    {sm.name}
                  </Select.Option>
                ))}
            </FormSelect>
          </Form.Item>
        </Col>
        <Col>
          <Form.Item>
            <ScopeButton type="primary" htmlType="submit">
              {t('users.change-owner')}
            </ScopeButton>
          </Form.Item>
          <Typography.Text type="danger">
            {t('other.change-owner-warning')}
          </Typography.Text>
        </Col>
      </Row>
    </Form>
  );
};
